// extracted by mini-css-extract-plugin
export var banner = "pages-list-banner-module--banner--olQgT";